import { SIDE_NAV_DARK, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig'

const institucionTheme = JSON.parse(localStorage.getItem('dataEscuela')) ?
JSON.parse(localStorage.getItem('dataEscuela')).theme : null

export const APP_NAME = 'Factura Siempre';
export const API_BASE_URL = env.API_ENDPOINT_URL
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const PUBLIC_PREFIX_PATH = '/p';

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_DARK,
	locale: 'mx',
	navType: NAV_TYPE_SIDE,
	topNavColor: '#3e82f7',
	headerNavColor: '#3e82f7',
	mobileNav: false,
	currentTheme: 'light',
	direction: DIR_LTR,
	btnColorPrimary:'#3e79f7',
	btnColorSecondary:'#fff',
	bgColorMenu: institucionTheme && institucionTheme.bgColorMenu || 'black' ,
	menuColorItem: institucionTheme && institucionTheme.menuColorItem || 'white',
	menuColorItemHover: institucionTheme && institucionTheme.menuColorItemHover || 'red',
	menuColorItemActive: institucionTheme && institucionTheme.menuColorItemHover || 'blue'
};

